import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from 'antd';
import { notification, Flex } from 'ui';
import QuestionSection from './question-section';

const Text = styled.p`
  ${p => p.marginTop && `margin-top: ${p.marginTop}px;`}
`;

const Buttons = styled(Flex)`
  > :first-child {
    margin-right: 5px;
  }
  justify-content: flex-end;
  margin-top: 15px;
`;

export const StyledButton = styled(Button)`
  text-transform: uppercase;
  border: 2px solid #6f7e95 !important;
  color: ${p => p.primary ? 'white' : '#6f7e95'} !important;
  background-color: ${p => p.primary ? '#6f7e95' : 'white'} !important;
  &:hover {
    border: 2px solid #6f7e95 !important;
    color: ${p => p.primary ? 'white' : '#6f7e95'} !important;
    background-color: ${p => p.primary ? '#6f7e95' : 'white'} !important;
    opacity: 0.7 !important;
  }
  &:focus {
    border: 2px solid #6f7e95 !important;
    color: ${p => p.primary ? 'white' : '#6f7e95'} !important;
    background-color: ${p => p.primary ? '#6f7e95' : 'white'} !important;
  }
  &:disabled {
    opacity: 0.7;
  }
  ${p => p.marginTop && `margin-top: ${p.marginTop}px`};
`;


export const QuestionWrapper = styled.div`
  margin: 15px 0;
`;

const QuestionWarning = ({
  intl,
  openQuestions,
  name = 'conclusionTags',
  form,
  allTags,
  onConfirm,
}) => {
  const [questions, setQuestions] = useState(openQuestions);
  const [answers, setAnswers] = useState([]);
  const [originalTags, setOriginalTags] = useState([]);

  useEffect(() => {
    setOriginalTags(form.getFieldValue(name));
  }, []);

  const handleAnswer = (e) => {
    const tags = form.getFieldValue(name);
    const newTag = allTags?.find(ct => ct.id === e);
    if (newTag) {
      form.setFieldsValue({
        [name]: [...tags, newTag],
      });
    }
    setAnswers(state => [...state, e]);
  };
  const handleUndo = (e) => {
    const tags = form.getFieldValue(name);
    form.setFieldsValue({
      [name]: tags?.filter(t => t.id !== e),
    });
    setAnswers(state => state?.filter(id => id !== e));
  };

  const handleClose = () => {
    form.setFieldsValue({
      [name]: [...originalTags],
    });
    setAnswers([]);
  };

  return (
    <>
      <Text>{intl.formatMessage({ id: 'ticket.QUESTION_WARNING_INFO' })}</Text>
      <Text marginTop={15}>
        {intl.formatMessage({ id: 'ticket.QUESTION_WARNING_INSTRUCTIONS' })}
      </Text>
      <QuestionWrapper>
        <QuestionSection
          intl={intl}
          questions={questions}
          setQuestions={setQuestions}
          handleQuestionAnswer={handleAnswer}
          handleQuestionUndo={handleUndo}
          hasUnknown={true}
          canUndo={true}
        />
      </QuestionWrapper>
      <Buttons>
        <StyledButton
          onClick={() => {
            handleClose();
            notification.destroy('openQuestionsWarning');
          }}
        >
          {intl.formatMessage({ id: 'common.CANCEL' })}
        </StyledButton>
        <StyledButton
          primary={1}
          onClick={() => {
            // TODO: UPGRADE - When upgrading to antd v4 this should be form.getFieldsValue(true)
            onConfirm(form.getFieldsValue());
            notification.destroy('openQuestionsWarning');
          }}
          disabled={answers.length !== questions.length}
        >
          {intl.formatMessage({ id: 'ticket.CLOSE_TICKET' })}
        </StyledButton>
      </Buttons>
    </>
  );
};
QuestionWarning.propTypes = {
  intl: PropTypes.object,
  openQuestions: PropTypes.array,
  form: PropTypes.object,
  name: PropTypes.string,
  allTags: PropTypes.array,
  onConfirm: PropTypes.func,
};

export default QuestionWarning;
